import { useEffect, useRef } from 'react';
import { IFRAME_PREFIX } from '@kizenapps/engine/communication';
import { isTrustedKizenMessageOrigin } from 'utility/messageOrigins';

export type KizenAiFrameMessageData = {
  action: string;
  [key: string]: unknown;
};

type Options = {
  iframeOnly?: boolean;
};

/**
 * Registers a window message listener that fires only for validated messages
 * sent from a kizen-ai-chat iframe
 */
export const useKizenAiFrameMessage = (
  callback: (data: KizenAiFrameMessageData) => void,
  options: Options = {}
): void => {
  const { iframeOnly = false } = options;

  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (iframeOnly && window.self === window.top) return;

    const handleMessage = (event: MessageEvent) => {
      if (
        isTrustedKizenMessageOrigin(event.origin) &&
        event.data?.__kizen?.frameId === `${IFRAME_PREFIX}-kizen_ai-chat`
      ) {
        callbackRef.current(event.data);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [iframeOnly]);
};
